import { render } from "./MFITTBookingSelectPaymentMethod.vue?vue&type=template&id=446cc126&scoped=true"
import script from "./MFITTBookingSelectPaymentMethod.vue?vue&type=script&lang=js"
export * from "./MFITTBookingSelectPaymentMethod.vue?vue&type=script&lang=js"

import "./MFITTBookingSelectPaymentMethod.vue?vue&type=style&index=0&id=446cc126&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-446cc126"

export default script